import parseSE from './se';
import parseFI from './fi';
import parseNO from './no';
import parseDK from './dk';

/**
 *
 * @param {*} nationalId - The national id to parse
 * @param {*} market - The market to parse the national id for (lower case)
 * @param {*} opts - Optional configuration object, for example
 * "allowTestNationalId: true". Only supported for FI market.
 * @returns parsed national id object
 */
export var parse = function parse(nationalId, market) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  switch (market) {
    case 'se':
      return parseSE(nationalId);
    case 'fi':
      return parseFI(nationalId, opts);
    case 'no':
      return parseNO(nationalId);
    case 'dk':
      return parseDK(nationalId);
    default:
      if (!market) {
        throw new Error('Undefined market');
      }
      throw new Error("".concat(market, " not recognized as a valid market."));
  }
};
export * from './constants';